<template>
  <div>
    <v-btn :disabled="enableButton()" v-show="this.$store.getters.isLoggedOn" icon :color="this.$store.getters.cartColor" @click="order()">
      <v-icon>md:shopping_cart</v-icon>{{ this.$store.getters.cartCounter }}
    </v-btn>    
  </div>
</template>

<script>
export default {
  name: "pl-shoppingcart",

  data: () => ({
  }),

  methods: {
    enableButton()
    {
      if (this.$store.getters.cartCounter==0)
      {
        return true;
      }
      else
        return false;
    },

    order()
    {
      if (this.$store.getters.cartCounter==0)
        this.$store.dispatch("setShowOrderForm", false);
      else
        this.$store.dispatch("setShowOrderForm", true);
    }

  }

};
</script>

<style scoped>
</style>
